import FormattedMessage from 'I18n/components/FormattedMessage';
import UIAlert from 'UIComponents/alert/UIAlert';
import UIIcon from 'UIComponents/icon/UIIcon';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const PriceChangeBanner = ({
  description,
  tooltip
}) => {
  return /*#__PURE__*/_jsxs(UIAlert, {
    titleText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "pricingPage.banners.priceChanges.headline"
    }),
    children: [description, tooltip ? /*#__PURE__*/_jsx(UITooltip, {
      placement: "top",
      title: tooltip,
      children: /*#__PURE__*/_jsx(UIIcon, {
        name: "info",
        size: "xxs",
        className: "m-left-1"
      })
    }) : null]
  });
};
export default PriceChangeBanner;